import React from 'react';
import { IntlProvider } from 'react-intl';
import Layout from './Layout';
import messages from './messages';
import { Navbar,Nav,Button,Form,FormControl } from 'react-bootstrap';

import MainPage from './MainPage';
function Init() {

  return (
   <IntlProvider>
<Layout/>
   </IntlProvider>

  );
}

export default Init;
